// extracted by mini-css-extract-plugin
export var completionBody = "_kz-2";
export var completionCard = "_kz-0";
export var completionFooter = "_kz-3";
export var completionTitle = "_kz-1";